import { render, staticRenderFns } from "./ApiManage.vue?vue&type=template&id=bff974d4&"
import script from "./ApiManage.vue?vue&type=script&lang=js&"
export * from "./ApiManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports